skrilla.controller('providerConnectionModalCtrl', function ($scope, searchService, modalService, bettingReferenceService) {

    $scope.providers =  bettingReferenceService.matchSourceTypes();

    $scope.manageConnection = function (action) {
        modalService.confirm(`Are you sure you'd like to ${action} ${$scope.query.provider} markets?`, function() {
            searchService.put(`betting/markets/providers/${$scope.query.provider}/${action}`, true,
                `Successfully requested to ${action} ${$scope.query.provider} markets\n
                    Please test that markets have been successfully ${action}ed !`)
        })
    }

});
